import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { SocialVerificationFragment } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type UserSocialVerificationsByServiceVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  service: Types.Scalars['social_verification_service_enum'];
}>;


export type UserSocialVerificationsByService = { socialVerifications: Array<Pick<Types.Social_Verification, 'id' | 'user' | 'createdAt' | 'updatedAt' | 'expiresAt' | 'lastCheckedAt' | 'socialVerificationURL' | 'verificationText' | 'userId' | 'username' | 'isValid' | 'service' | 'failedReason' | 'status'>> };



export const UserSocialVerificationsByServiceDocument = /*#__PURE__*/ `
    query UserSocialVerificationsByService($publicKey: String!, $service: social_verification_service_enum!) {
  socialVerifications: social_verification(
    where: {user: {_eq: $publicKey}, service: {_eq: $service}}
    limit: 1
    order_by: {createdAt: desc}
  ) {
    ...SocialVerificationFragment
  }
}
    ${SocialVerificationFragment}`;

export const useUserSocialVerificationsByService = <
      TData = UserSocialVerificationsByService,
      TError = ClientError
    >(
      variables: UserSocialVerificationsByServiceVariables,
      options?: Omit<UseQueryOptions<UserSocialVerificationsByService, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserSocialVerificationsByService, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserSocialVerificationsByService, TError, TData>(
      {
    queryKey: ['UserSocialVerificationsByService', variables],
    queryFn: hasuraFetcher<UserSocialVerificationsByService, UserSocialVerificationsByServiceVariables>(UserSocialVerificationsByServiceDocument, variables),
    ...options
  }
    )};

useUserSocialVerificationsByService.getKey = (variables: UserSocialVerificationsByServiceVariables) => ['UserSocialVerificationsByService', variables];

export const useInfiniteUserSocialVerificationsByService = <
      TData = InfiniteData<UserSocialVerificationsByService>,
      TError = ClientError
    >(
      variables: UserSocialVerificationsByServiceVariables,
      options: Omit<UseInfiniteQueryOptions<UserSocialVerificationsByService, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserSocialVerificationsByService, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserSocialVerificationsByService, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserSocialVerificationsByService.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<UserSocialVerificationsByService, UserSocialVerificationsByServiceVariables>(UserSocialVerificationsByServiceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserSocialVerificationsByService.getKey = (variables: UserSocialVerificationsByServiceVariables) => ['UserSocialVerificationsByService.infinite', variables];


useUserSocialVerificationsByService.fetcher = (variables: UserSocialVerificationsByServiceVariables, options?: RequestInit['headers']) => hasuraFetcher<UserSocialVerificationsByService, UserSocialVerificationsByServiceVariables>(UserSocialVerificationsByServiceDocument, variables, options);
